---
de:
  budget_actions:
    create_custom_budget: Individuelles Budget erstellen
    learn_more: Wie werden Prognosen berechnet?
    update_import: Budgetdaten aktualisieren
  budget_export:
    export_button: Budgetdaten exportieren
  budget_grouping:
    display: Anzeige
    view_by: Ansicht nach
  budget_import:
    description: Exportieren Sie Budgetdaten, ändern Sie sie in Excel und importieren Sie die aktualisierte XLSX-Datei hier. Kraftwerke sind in Spalten, Monate sind in Zeilen. Das System erkennt automatisch das Jahr aus Zeile 4.
    invalid_file_type: Nur XLSX-Dateien werden unterstützt
    upload_error: Fehler beim Importieren von Budgetdaten
    upload_success: Budgetdaten erfolgreich importiert
    upload_success_with_details: "%{count} Budgeteinträge für Jahr %{year} erfolgreich importiert"
  budget_source:
    actual_budgets: Zeigt tatsächliche Budgetdaten
    actual_message: Diese Daten spiegeln die tatsächliche Produktion und Einnahmen aus der Vergangenheit wider.
    actual_title: Zeigt tatsächliche Budgetdaten
    forecasted_budgets: Zeigt prognostizierte Budgetdaten
    forecasted_message: Dies sind berechnete Prognosen basierend auf historischen Mustern. Erstellen Sie ein individuelles Budget, um Ihre eigenen Werte zu verwenden.
    forecasted_title: Zeigt prognostizierte Budgetdaten
    imported_budgets: Zeigt importierte zukünftige Budgetdaten
    imported_message: Sie haben Budgetdaten für dieses Jahr hochgeladen.
    imported_title: Zeigt importierte Budgetdaten
  budgets_for: Budgets für
  dialog:
    new_budget_forecast: Neue Budgetprognosen
    unavailable_price_areas: "%{price_areas} wurden bereits erstellt. Klicken Sie auf 'Produktionsprofil', um zu bearbeiten"
  errors:
    messages:
      budget_already_saved: Das Budget wurde bereits gespeichert!
      no_forcasts_for_this_year: Keine Prognosen für %{year}
      total_percent: Gesamtprozent muss genau 100 sein
  profile:
    average: Durchschnitt
    price_chart: Preisdiagramm
    price_profile: Preisprofil
    production_profile: Produktionsprofil
    production_profile_chart: Produktionsprofildiagramm
    revenue_chart: Erlösdiagramm
    revenue_profile: Erlösprofil
    save_budget: Budget speichern
    total: Gesamt
    validations:
      non_negative: Kann nicht negativ sein
      required: Erforderlich
